import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2d647a78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onMousedown"]

import { computed, nextTick, onMounted, Ref, ref, watch } from "vue";

// Определение эмиттеров событий компонента
const autocomplete = true;

export default /*#__PURE__*/_defineComponent({
  __name: 'ui-select-autocomplete',
  props: {
	keyField: { type: String },
	valueField: { type: String },
	items: { type: Array<any>, default: [] },
	isWrong: { type: Boolean, default: false },
	selectText: { type: String },
	closeOnSelect: { type: Boolean, default: true },
	checkActiveByRef: { type: Boolean, default: false },
	defaultText: { type: String, default: "" },
	headerText: { type: String, default: "" },
	noUndefined: { type: Boolean, default: false },
	modelValue: { type: [Object, Array, String, Number, Date], default: null },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

// Определение пропсов компонента
const props = __props;

const searchEl = ref();

const innerValue: Ref<any | any[] | String | Number | string | number | Date> = ref();
const innerItems: Ref<any[]> = ref(props.items);
const hoveredIdx: Ref<number> = ref(0);

const hasFocus = ref(false);
const search = ref("");
const open = ref(false);
const preventCurrentClick = ref(false);

watch(
	() => props.modelValue,
	(value) => {
		innerValue.value = value;
	}
);

watch(
	() => innerValue.value,
	() => {
		emits("update:modelValue", innerValue.value);
	}
);

watch(
	() => props.items,
	(value) => {
		if (value) {
			innerItems.value = value;
		}
	}
);

const itemsToDisplay = computed(() => {
	let res = innerItems.value.filter((x) =>
		(getValue(x) || "").toLowerCase().includes(search.value.toLowerCase())
	);
	if (!props.noUndefined) {
		res = [undefined].concat(res);
	}
	return res;
});

const active = computed(() => {
	const fi = innerItems.value.find((el: any) => isEqual(getKey(el), innerValue.value));
	return fi || null;
});

	function activeText(): string {
	if (Array.isArray(active.value)) {
		return active.value.length > 0
			? active.value.map((el: any) => getValue(el)).join(", ")
			: props.selectText || "";
	} else {
		return active.value ? getValue(active.value) : props.defaultText;
	}
}

onMounted(() => {
	innerValue.value = props.modelValue;
	document.addEventListener("keydown", onKeyDown.bind(this));
});

function select(item: any) {
		if (item === undefined) {
			innerValue.value = undefined;
			if (props.closeOnSelect) {
				setTimeout(() => setOpen(false), 100); // Небольшая задержка перед закрытием
			}
			return;
		}

		innerValue.value = getKey(item);

		if (props.closeOnSelect) {
			setTimeout(() => setOpen(false), 100);  // Небольшая задержка перед закрытием
		}

		search.value = "";
		setHoveredIdx(innerItems.value.indexOf(item));
	}

function setOpen(value: boolean) {
	open.value = value;
	if (value) {
		nextTick(() => {
			(searchEl.value as HTMLInputElement).focus();
		});
	}
	const activeIdx = Array.isArray(active.value)
		? itemsToDisplay.value.indexOf(active.value[active.value.length - 1])
		: itemsToDisplay.value.indexOf(active.value);
	setHoveredIdx(activeIdx);
}

function setHoveredIdx(idx: number) {
	hoveredIdx.value = (idx + itemsToDisplay.value.length) % itemsToDisplay.value.length;
}

function onKeyDown(ev: KeyboardEvent) {
	if (!hasFocus.value) {
		return;
	}
	var key = ev.key.toLowerCase();
	if (key == "escape") {
		return (open.value = false);
	}
	if (key == "enter") {
		return open.value ? onEnter() : setOpen(true);
	}
	if (key == "arrowdown" || key == "arrowup") {
		ev.preventDefault();
		return open.value
			? key === "arrowdown"
				? setHoveredIdx(++hoveredIdx.value)
				: setHoveredIdx(--hoveredIdx.value)
			: setOpen(true);
	}
}

function onEnter() {
	select(itemsToDisplay.value[hoveredIdx.value]);
}

function clickCurrent() {
	if (preventCurrentClick.value) {
		return;
	}
	setOpen(!open.value);
}

function onGetFocus() {
	setOpen(true);
	preventCurrentClick.value = true;
	setTimeout(() => (preventCurrentClick.value = false), 300);
	hasFocus.value = true;
}

function onBlur() {
	setOpen(false);
	hasFocus.value = false;
}

function isSelect(item: any) {
	if (item === undefined) return innerValue.value === undefined;
	var key = getKey(item);
	return isEqual(key, innerValue.value);
}

function isEqual(fst: any, scd: any): boolean {
	return props.checkActiveByRef
		? fst === scd
		: JSON.stringify(fst) === JSON.stringify(scd);
}

function getKey(item: any) {
	if (props.keyField) {
		return item[props.keyField];
	}
	return item;
}

function getValue(item: any) {
	if (props.valueField) {
		const resText = item[props.valueField];
		if (resText == undefined) {
			console.error("Не найден valueField");
		}
		return resText ? resText.toUpperCase() : "";
	}
	return item.toUpperCase();
}

return (_ctx: any,_cache: any) => {
  const _component_ui_scroll = _resolveComponent("ui-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    tabindex: "0",
    onFocusin: onGetFocus,
    onFocusout: onBlur,
    ref: "root",
    class: "ui-select"
  }, [
    (__props.headerText.length != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ui_input_header", [__props.isWrong ? 'wrong_text' : '']])
        }, _toDisplayString(__props.headerText), 3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", {
      class: "",
      onMousedown: clickCurrent
    }, [
      _renderSlot(_ctx.$slots, "current", {
        key: innerValue.value,
        value: active.value
      }, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["current", { active: open.value, wrong: __props.isWrong }])
        }, _toDisplayString(innerValue.value ? activeText() : props.defaultText), 3)
      ])
    ], 544), [
      [_vShow, !open.value]
    ]),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            ref_key: "searchEl",
            ref: searchEl,
            class: _normalizeClass(["current-input", [__props.isWrong ? 'wrong' : '']]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event))
          }, null, 2), [
            [_vModelText, search.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container_wrapper", { active: open.value }])
    }, [
      _renderSlot(_ctx.$slots, "container", { data: itemsToDisplay.value }, () => [
        _createElementVNode("div", {
          class: _normalizeClass(["container", { active: open.value }])
        }, [
          _createVNode(_component_ui_scroll, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsToDisplay.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["item", { active: isSelect(item), hover: index == hoveredIdx.value }]),
                  key: index,
                  onMousedown: ($event: any) => (select(item))
                }, [
                  (item === undefined)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(__props.defaultText), 1)
                      ], 64))
                    : _renderSlot(_ctx.$slots, "item", {
                        key: 1,
                        item: item,
                        index: index,
                        hover: index == hoveredIdx.value,
                        active: isSelect(item)
                      }, () => [
                        _createTextVNode(_toDisplayString(getValue(item)), 1)
                      ])
                ], 42, _hoisted_2))
              }), 128))
            ]),
            _: 3
          })
        ], 2)
      ])
    ], 2)
  ], 544))
}
}

})